import { useMutation, useQuery, type UseQueryOptions, type UseMutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient';
import type { Chat } from '@trinity/chat';

type Props = {
  chatInstanceIdentifier: string;
};

type Data = Awaited<Chat.Session>;
type Options = UseQueryOptions<Data, AxiosError, Data, QueryKey>;
type QueryKey = readonly [string, Props];

function getQueryKey(props: Props): QueryKey {
  return [`chat:get:instance`, props];
}

export const useChatInstanceQuery = (props: Props, options?: Options) => {
  const qk = getQueryKey(props);

  const apiClient = useChatApiClient();

  return useQuery({
    queryKey: qk, queryFn: ({ queryKey }) => {
      return apiClient.chatInstances.getChatInstance({
        chatInstanceIdentifier: queryKey[1].chatInstanceIdentifier,
      });
    },
    ...options,
  });
};

type MutationOptions = UseMutationOptions<Data, AxiosError, Props>;

export const useFetchChatInstanceMutation = (options?: MutationOptions) => {
  const apiClient = useChatApiClient();

  return useMutation({
    mutationKey: [`chat:get:instance`], mutationFn: ({ chatInstanceIdentifier }) => {
      return apiClient.chatInstances.getChatInstance({
        chatInstanceIdentifier,
      });
    },
    ...options,
  });//try getting into brand object
};